import clsx from 'clsx';
import type { JSX } from 'react';

interface ArbiToggleProps {
  checked: boolean;
  onChange: (newValue: boolean) => void;
  disabled?: boolean;
  label: string;
  tooltip?: string;
}

/**
 * ArbiToggle — custom toggle switch. Never uses input[type=checkbox].
 */
export default function ArbiToggle({
  checked,
  onChange,
  disabled = false,
  label,
  tooltip,
}: ArbiToggleProps): JSX.Element {
  return (
    <button
      role="switch"
      aria-checked={checked}
      aria-label={label}
      title={tooltip}
      disabled={disabled}
      onClick={() => !disabled && onChange(!checked)}
      className={clsx(
        'relative inline-flex items-center w-8 h-[18px] rounded-full transition-colors duration-150 flex-shrink-0',
        disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer',
        checked ? 'bg-accent' : 'bg-surface-4'
      )}
    >
      <span
        className={clsx(
          'absolute w-3.5 h-3.5 rounded-full bg-white transition-transform duration-150 shadow-sm',
          checked ? 'translate-x-[14px]' : 'translate-x-0.5'
        )}
      />
    </button>
  );
}
